import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

@Injectable()
export class ErrorService {
  constructor(private http: HttpClient) {}

  assignUserToProject(projectId: string): Promise<boolean> {
    return this.http.post<{success: boolean}>(`/api/projects/assign-user-to-project`, {projectId})
      .pipe(map(json => json && !!json.success))
      .toPromise();
  }
}
